<template>
  <OfferComparisonCard
    :benefits
    dialog-name="us-telco-comparators-us-mobile"
    :name="i18n(translations.name)"
    :price="i18n(translations.price)"
    tracking-value="us_mobile"
    :trustpilot-rating="Number(i18n(translations.trustpilotRating))"
  >
    <template #logo>
      <div class="rounded-full overflow-hidden">
        <RevIllustration
          alt=""
          class="size-32 shrink-0"
          :height="32"
          src="/img/telco-partnership/us-mobile.svg"
          :width="32"
        />
      </div>
    </template>

    <template #info>
      <RevInfoBlock
        :content="i18n(translations.promoContent)"
        :icon="IconPriceTag"
        :title="i18n(translations.promoTitle)"
        variant="success"
      />
    </template>

    <template #modal>
      <div class="space-y-24">
        <RevIllustration
          alt=""
          :height="192"
          image-class-names="w-full h-auto"
          src="/img/telco-partnership/us-mobile-cobranded.png"
          :width="654"
        />

        <ModalStepsList :steps="modalSteps" />

        <RevButton
          full-width="always"
          target="_blank"
          :to="i18n(translations.modalCtaLink)"
          :tracking="{
            zone: 'telco_instructional_popup',
            name: 'get_started',
            value: 'us_mobile',
          }"
          variant="primary"
        >
          <span class="flex items-center gap-4">
            {{ i18n(translations.modalCtaLabel) }}
            <IconExternalLink size="medium" />
          </span>
        </RevButton>
      </div>
    </template>
  </OfferComparisonCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconExternalLink } from '@ds/icons/IconExternalLink'
import { IconPriceTag } from '@ds/icons/IconPriceTag'

import OfferComparisonCard from '../OfferComparisonCard/OfferComparisonCard.vue'
import ModalStepsList from '../OfferComparisonCard/components/ModalStepsList/ModalStepsList.vue'

import translations from './USMobileOfferCard.translations'

const i18n = useI18n()

const benefits = computed(() => [
  i18n(translations.benefitNetworks),
  i18n(translations.benefitUnlimited),
  i18n(translations.benefitInternational),
])

const modalSteps = computed(() => [
  i18n(translations.modalStep1),
  i18n(translations.modalStep2),
  i18n(translations.modalStep3),
])
</script>
